export const COMMISSION_RULE_COLUMNS_WITHOUT_CURRENCY = [
  'segmentDescription',
  'initialPercentage',
  'lowerThreshold',
  'threshold',
  'value',
  'maxValue',
];

export const COMMISSION_RULE_COLUMNS_WITH_CURRENCY = [
  'segmentDescription',
  'currencyIsoCode',
  'initialPercentage',
  'lowerThreshold',
  'threshold',
  'value',
  'maxValue',
];
